var map = {
	"./core/Logo": [
		198,
		198
	],
	"./demo/Logo": [
		5806,
		806
	],
	"./demo/bet365/Logo": [
		2400,
		400
	],
	"./demo/bnq/Logo": [
		434,
		434
	],
	"./demo/bupa/Logo": [
		1755,
		755
	],
	"./demo/rubicon/Logo": [
		4713,
		713
	],
	"./demo/screwfix/Logo": [
		7038,
		38
	],
	"./demo/test/Logo": [
		2025,
		25
	],
	"./demo/tfl/Logo": [
		4808,
		427
	],
	"./gravity/Logo": [
		379,
		379
	],
	"./miroma/Logo": [
		850,
		850
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5183;
module.exports = webpackAsyncContext;